<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Choose affiliate</ion-title>
  </ion-toolbar>

  @if (!affiliate) {
    <ion-toolbar>
      <ion-searchbar #search_bar_input placeholder="Search for an affiliate" debounce="200" [(ngModel)]="query" (ionInput)="searchAffiliates()"></ion-searchbar>
    </ion-toolbar>
  }

</ion-header>

<ion-content>

  @if (affiliate) {
    <div>
      <ion-item lines="full">
        <ion-label>{{affiliate.name}}</ion-label>
        <fa-icon [icon]="['fal', 'times']" size="lg" (click)="clear()" slot="end"></fa-icon>
      </ion-item>
    </div>
  }

  @if (!affiliate) {
    <div>
      @if (!loading && visible_affiliates && visible_affiliates.length != 0) {
        <ion-list>
          @for (affiliate of visible_affiliates; track affiliate) {
            <ion-item lines="full" button="true" (click)="select(affiliate.id)">
              <ion-label>{{affiliate.name}}</ion-label>
            </ion-item>
          }
        </ion-list>
      }
    </div>
  }

  @if (!loading && visible_affiliates && visible_affiliates.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'chart-pie-simple-circle-dollar']" size="4x"></fa-icon>
            <span>No affiliates found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>

